import { render } from "./IconGlyph.vue?vue&type=template&id=4e561140&ts=true"
import script from "./IconGlyph.vue?vue&type=script&lang=ts"
export * from "./IconGlyph.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__